// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w_rzKOuY4UkjWhcJxYFm{color:var(--content-primary-tertiary);padding:16px 20px 8px}.NDgodbEzglPzAzHupsiI{color:var(--content-primary-tertiary);flex-direction:column;justify-content:center;align-items:center;margin-top:35vh;display:flex}.NDgodbEzglPzAzHupsiI p{font-size:14px;line-height:20px}.Ey0bSsNUD9gEkShd5JsJ{flex-grow:1;height:100%;margin-top:1px;padding:7px;position:relative;overflow-x:hidden;overflow-y:auto}.osOjkTun9YQDRyuLvOIQ{text-align:center;justify-content:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"total": `w_rzKOuY4UkjWhcJxYFm`,
	"listStatus": `NDgodbEzglPzAzHupsiI`,
	"inboxes": `Ey0bSsNUD9gEkShd5JsJ`,
	"loadingMore": `osOjkTun9YQDRyuLvOIQ`
};
export default ___CSS_LOADER_EXPORT___;
